<template>
  <div class="right-panel-multi-tabs">
    <aha-multi-tabs
      :tabTitles="tabTitles"
      :key="tab"
      :defaultTabIndex="tab"
      closeable
      @onChangeTab="activeTab"
      @onCloseButtonClicked="closePanel()"
    >
      <template #tab-0>
        <ThemeSetting v-if="canViewThemeGallery" />
        <DesignEditPanel
          v-else
          @on-click-link-to-chart-color="() => activeTab(TABS.SLIDES)"
        />
      </template>

      <template #tab-1>
        <CustomizePanel v-if="canViewThemeGallery" />
        <ColorPaletteConfig v-else />
      </template>
    </aha-multi-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import DesignEditPanel from '@/components/presentations/types/DesignEditPanel.vue'
import ColorPaletteConfig from '@/components-v2/presentation-editor/side-right/right-nav/ColorPaletteConfig.vue'
import ThemeSetting from '@/components-v2/presentation-editor/side-right/right-nav/ThemeSetting.vue'
import RightNavTabs from '@/constant/RightNavTabs'
import CustomizePanel from '@/components-v2/presentation-editor/side-right/right-nav/CustomizePanel.vue'
import redirectMixin from '@/mixins/redirect'

const { SUB_TABS, TAB_NAMES } = RightNavTabs

export default {
  name: 'DesignPanelWrapper',
  components: {
    DesignEditPanel,
    ColorPaletteConfig,
    ThemeSetting,
    CustomizePanel,
  },
  mixins: [redirectMixin],
  data() {
    return {
      TABS: SUB_TABS[TAB_NAMES.DESIGN],
    }
  },
  computed: {
    ...mapGetters('themeModule', ['canCreateTheme', 'canViewThemeGallery']),
    tabTitles() {
      if (this.canViewThemeGallery) return ['Themes', 'Customize']
      return ['Customize', 'Themes']
    },
    tab() {
      const activeTab = Number(this.queryParams?.activeTab)
      return Number.isInteger(activeTab) ? activeTab : this.TABS.PRESENTATION
    },
  },
  methods: {
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
    closePanel() {
      this.setRightNavActiveTabAction('')
    },
    activeTab(tabIndex) {
      this.redirectTo({
        query: { activeTab: tabIndex },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss-v2/variables.scss';

.right-panel-multi-tabs {
  overflow-y: auto;
  @apply h-full;
  .multi-tabs {
    @apply overflow-hidden relative;
  }
  &::v-deep {
    .no-header .multi-tabs__header{
      display: none;
    }
    .multi-tabs__content {
      @apply h-full;
    }
    .aha-tabs {
      @apply fixed top-0 z-10 border-b border-base-30 bg-base-0;
      @apply px-4 rounded-tl-lg rounded-tr-lg;
      @apply flex items-end justify-between;
      @apply font-bold text-base text-secondary-100;
      width: 382px;
      height: 55px;
      .aha-tab-content {
        @apply h-full;
      }
      .aha-tab-title {
        padding-top: 15.5px;
        padding-bottom: 12.5px;
        margin-right: 2rem;
        &.active {
          border-bottom-width: 3px;
        }
      }
    }
  }
}
</style>
